type EventCallback = (eventName: string, data?: any) => void;

const eventListeners = new Map<string, EventCallback[]>();

export const on = (eventName: string, callback: EventCallback) => {
	if (!eventListeners.has(eventName)) {
		eventListeners.set(eventName, []);
	}
	eventListeners.get(eventName)?.push(callback);
};

export const off = (eventName: string, callback: EventCallback) => {
	const listeners = eventListeners.get(eventName);
	if (listeners) {
		const index = listeners.indexOf(callback);
		if (index > -1) {
			listeners.splice(index, 1);
		}
	}
};

export const emit = (eventName: string, data?: any) => {
	const listeners = eventListeners.get(eventName);
	if (listeners) {
		listeners.forEach((callback) => callback(eventName, data));
	}
};
